export default () => ({
  opened: false,
  defaultContent: 'Oops, content has not been set',
  content: '',
  open(event) {
    this.opened = true
    document.body.style.overflow = 'hidden'
    this.content = typeof event.detail.content !== 'undefined' && event.detail.content ? event.detail.content : this.defaultContent
  },
  close() {
    if(this.opened) {
      this.opened = false
      document.body.style.overflow = 'initial'
    }
  }
})
